import { render, staticRenderFns } from "./AssignMenuPermissions.vue?vue&type=template&id=5d4678ca&scoped=true"
import script from "./AssignMenuPermissions.vue?vue&type=script&lang=js"
export * from "./AssignMenuPermissions.vue?vue&type=script&lang=js"
import style0 from "./AssignMenuPermissions.vue?vue&type=style&index=0&id=5d4678ca&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4678ca",
  null
  
)

export default component.exports